import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import "../../styles/productFilters-styles.scss"
import ProductFilterView from './Includes/ProductFilterView'
import AddFilterCriteriaCard from '../AddFilterCriteria/Includes/AddFilterCriteriaCard'
import { getProductFilters, updateProductFilters } from 'utlis/Apis/ProductFilters_API'
import { toast } from 'react-toastify'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_FETCHING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE_UPDATING_PRODUCTFILTERS } from 'utlis/AppMessages/AppMessages'

function ProductFilters(props) {
    const [productFilters, setProductFilters] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        getProductFilters(props.currentUser.userToken).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setProductFilters(arr => resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PRODUCTFILTERS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getProductFilters `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [props.currentUser.token, props])

    const updateProductFilters_ = (productFilters_) => {
        setProductFilters(arr => [...productFilters_])
        updateProductFilters(props.currentUser.userToken, {
            filterlist: productFilters_

        }).then(res => {
            const resData = res.data
            if (resData && resData.error) {
                toast.dismiss(
                    setLoading(true),
                );
                toast.error(ERROR_WHILE_UPDATING_PRODUCTFILTERS, {
                    autoClose: 3000,
                    onClose: () => {
                        setLoading(false)
                    }
                })
            }
        })

    }

    return (
        <section id="app-product-filters" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Product Filters</p>
                    </div>
                    <Row className="product-filter-left-content">
                        <Col lg={3} md={12}>
                            <p className="product-filter-subheading">Filter Criteria</p>
                            <p className="product-filter-desc">
                                These filter criteria are currently available for your customers in your store.
                            </p>
                        </Col>
                        <Col lg={9} md={12} className="product-filter-right-content">
                            <ProductFilterView
                                productFilters={productFilters}
                                loading={loading}
                                updateProductFilters_={updateProductFilters_}
                            />
                        </Col>
                    </Row>
                </div>
                <div className="app-product-filters">
                    <Row className="product-filter-left-content">
                        <Col lg={3}>
                            <p className="product-filter-subheading">Add Filter Criteria</p>
                            <p className="product-filter-desc">
                                Select criteria by which you would like your customers to narrow down their product searches.
                            </p>
                        </Col>
                        <Col lg={9} className="product-filter-right-content">
                            <AddFilterCriteriaCard />
                        </Col>
                    </Row>
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(ProductFilters)